import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../utils/sitecoreContext';
import useFetchDealer from '../../../core/apiHooks/useFetchDealer';
import getDealerStatus from './utils/getDealerStatus';
var useDealerStatusAndHours = function () {
    var _a;
    var dealer = useFetchDealer().data;
    var language = useLanguage();
    var locale = "".concat((_a = language === null || language === void 0 ? void 0 : language.toLowerCase) === null || _a === void 0 ? void 0 : _a.call(language), "-CA");
    var dealerCode = dealer === null || dealer === void 0 ? void 0 : dealer.dealerCode;
    var dealerName = dealer === null || dealer === void 0 ? void 0 : dealer.dealerOperatingName;
    var dealerHours = dealer === null || dealer === void 0 ? void 0 : dealer.hours;
    var dealerTimezone = dealer === null || dealer === void 0 ? void 0 : dealer.dealerTimeZone;
    var t = useTranslation().t;
    var dayOfWeekNames = [
        '',
        t('Shared.Common.mondayLabel'),
        t('Shared.Common.tuesdayLabel'),
        t('Shared.Common.wednesdayLabel'),
        t('Shared.Common.thursdayLabel'),
        t('Shared.Common.fridayLabel'),
        t('Shared.Common.saturdayLabel'),
        t('Shared.Common.sundayLabel'),
    ];
    var amLabel = t('Shared.Common.amLabel');
    var pmLabel = t('Shared.Common.pmLabel');
    var isDealerDataAvailable = !!(dealerCode &&
        dealerName &&
        dealerTimezone &&
        Array.isArray(dealerHours) &&
        dealerHours.length);
    var dealerStatus = isDealerDataAvailable ? getDealerStatus(dealerHours, dealerTimezone, locale) : null;
    // return early if dealer hours/status data is not valid
    if (!dealerStatus)
        return {
            isDealerDataAvailable: isDealerDataAvailable,
            dealerCode: dealerCode,
            dealerName: dealerName,
            isDealerOpen: false,
            message: t('Shared.Common.noDealerHoursLabel'),
            isHoursUnavailable: true,
        };
    var isDealerOpen = dealerStatus.isDealerOpen;
    var getTimeStr = function (obj) { return "".concat(obj.time, " ").concat(obj.isAM ? amLabel : pmLabel); };
    var message = isDealerOpen
        ? t('Shared.Common.closesAtLabel', {
            closingTime: getTimeStr(dealerStatus.closingTime),
        })
        : t('Shared.Common.opensAtLabel', {
            day: dayOfWeekNames[dealerStatus.nextOpenDay],
            openingTime: getTimeStr(dealerStatus.openingTime),
        });
    return {
        isDealerDataAvailable: isDealerDataAvailable,
        dealerCode: dealerCode,
        dealerName: dealerName,
        isDealerOpen: isDealerOpen,
        message: message,
        isHoursUnavailable: false,
    };
};
export default useDealerStatusAndHours;
